import { useContext } from 'react';
import AuthContext from '../contexts/KeycloakContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
